<div class="sign-documents-milestone sign-documents-milestone--{{ state }}">
  <div class="sign-documents-milestone__left">
    <div class="sign-documents-milestone__icon-wrapper sign-documents-milestone__icon-wrapper--{{ state }}">
      <img class="sign-documents-milestone__icon" [src]="getIconPath()" alt="" aria-hidden="true" />
    </div>

    <ng-container>
      <div class="sign-documents-milestone__sign-content">
        <span *ngIf="hasContractReadyToSign" class="sign-documents-milestone__text">
          Contratos listos para firma.
        </span>
        <ng-container *ngIf="!hasContractReadyToSign" [ngSwitch]="latfStatus">
          <span *ngSwitchCase="LaftStatus.InReview" class="sign-documents-milestone__text">
            Revisando tu información y preparando los documentos para la firma.
          </span>
          <span *ngSwitchCase="LaftStatus.SignatureRequested" class="sign-documents-milestone__text">
            Documentos listos para firma.
          </span>
          <ng-container *ngSwitchCase="LaftStatus.PepRequested">
            <span class="sign-documents-milestone__text">Ya casi terminamos</span>
            <p class="sign-documents-milestone__description">Confirma si algún representante legal es o ha sido PEP</p>
          </ng-container>
          <ng-container *ngSwitchCase="LaftStatus.Error">
            <span class="sign-documents-milestone__text">Ocurrió un error al procesar tu firma</span>
            <p class="sign-documents-milestone__description">Asegúrate de que tu rostro y documento de identidad sean capturados correctamente.</p>
          </ng-container>
          <span *ngSwitchDefault class="sign-documents-milestone__text">Firmar documentos</span>
        </ng-container>
        
        <ul
          class="sign-documents-milestone__list"
          *ngIf="
            !hasContractReadyToSign &&
            !isCompleted() &&
            latfStatus !== LaftStatus.InReview &&
            latfStatus !== LaftStatus.PepRequested &&
            latfStatus !== LaftStatus.SignatureRequested &&
            latfStatus !== LaftStatus.Error
          "
          role="list"
        >
          <li class="sign-documents-milestone__item">
            <span class="sign-documents-milestone__status">
              <ng-container [ngSwitch]="latfStatus">
                <img
                  *ngSwitchCase="LaftStatus.Completed"
                  class="sign-documents-milestone__status-icon"
                  src="assets/icons/check_circle-24px.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span
                  *ngSwitchCase="LaftStatus.InReview"
                  class="sign-documents-milestone__status-circle sign-documents-milestone__status-circle--in-review"
                  aria-hidden="true"
                ></span>
                <span *ngSwitchDefault class="sign-documents-milestone__status-circle" aria-hidden="true"></span>
              </ng-container>
            </span>
            <span class="sign-documents-milestone__label">Declaración jurada</span>
          </li>
          <li class="sign-documents-milestone__item">
            <span class="sign-documents-milestone__status">
              <img
                *ngIf="signed"
                class="sign-documents-milestone__status-icon"
                src="assets/icons/check_circle-24px.svg"
                alt=""
                aria-hidden="true"
              />
              <span *ngIf="!signed" class="sign-documents-milestone__status-circle" aria-hidden="true"></span>
            </span>
            <span class="sign-documents-milestone__label">Contrato</span>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>

  <div class="sign-documents-milestone__btn-actions">
    <button
      class="sign-documents-milestone__btn"
      *ngIf="
        (hasContractReadyToSign || (!isCompleted() && latfStatus !== LaftStatus.InReview && latfStatus !== LaftStatus.Error))
      "
      type="button"
      (click)="onSignDocumentsBannerClick()"
    >
      {{ buttonLabel }}
    </button>
    <button
      #errorButton
      *ngIf="latfStatus === LaftStatus.Error"
      class="error-button"
      (click)="onSignDocumentsBannerClick()"
    >
      {{ buttonLabel }}
    </button>
  </div>
</div>
